import styles from "./journalfilter.module.css";
import { useState } from "react";
import { ArrowRight, Calendar, Filter, Plus, Search } from "react-feather";
import dayjs from "dayjs";
import { DateRangePicker } from "rsuite";
import { Link } from "react-router-dom";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useAuth0 } from "@auth0/auth0-react";

const JournalFilter = ({ filterDateRange, propertyList, userList, setFilterData, setOpenAddForm, setFilterDateRange }) => {
    const [filterOpen, setFilterOpen] = useState(false);
    const { user, isAuthenticated } = useAuth0();

    const disableDate = (date) => {
        const d = dayjs(date);
        return d.isAfter(dayjs(), 'day');
    }

    return (<div className={`${styles.SearchFilterSec}`}>
        <div className={`${styles.SearchCon}`}>
            <div className={`${styles.SearchConSec}`}>
                <Search />
                <input type="text" placeholder="Search" onChange={(e) => setFilterData(prev => {
                    return { ...prev, searchKey: e.target.value }
                })} />
            </div>
        </div>

        <div className={`${styles.FilterSec}`}>
            <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
                <p className={`${styles.FilterTitle}`}>
                    Filters
                    <span onClick={(e) => setFilterOpen(false)}>
                        <ArrowRight />
                    </span>
                </p>
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width200} CusSelectFilter Filter`}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Property</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Property"
                            onChange={(e) => setFilterData(prev => {
                                return { ...prev, property: e.target.value }
                            })}
                        >
                            <MenuItem value="all">All Property</MenuItem>
                            {propertyList?.map(i => {
                                return <MenuItem value={i?.id}>{i?.name}</MenuItem>
                            })}
                        </Select>
                    </FormControl>
                </div>
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width200} CusSelectFilter Filter`}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">User</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="User"
                            onChange={(e) => setFilterData(prev => {
                                return { ...prev, user: e.target.value }
                            })}
                        >
                            <MenuItem value="all">All</MenuItem>
                            {userList?.map(i => {
                                return <MenuItem value={i?.id}>{i?.full_name}</MenuItem>
                            })}
                        </Select>
                    </FormControl>
                </div>
                <div className={`${styles.FilterCard}`}>
                    <div className={`${styles.DashFilterSec} DashFilterSec Filter`}>
                        <DateRangePicker
                            format={"MM/dd/yy"}
                            placeholder={"Filter by date"}
                            placement={"bottomEnd"}
                            caretAs={Calendar}
                            showOneCalendar
                            value={filterDateRange}
                            onChange={(date) => {
                                setFilterDateRange(date);
                            }}
                        />
                    </div>
                </div>
            </div>
            <Link className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}>
                <Filter />
            </Link>
            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("journal:create") > -1 && <Link className={`${styles.AddNoteBu}`} onClick={(e) => setOpenAddForm(true)}>
                <Plus /> <span>Journal</span>
            </Link>}
        </div>
    </div>);
};

export default JournalFilter;